import { apiRequest } from "./apiClient";

const categoryImages = {
  cell: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=700&q=80",
  inverter: "https://images.unsplash.com/photo-1562408590-e32931084e23?auto=format&fit=crop&w=700&q=80",
  "bms-smart": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=700&q=80",
  "battery-pack": "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?auto=format&fit=crop&w=700&q=80",
  charger: "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b?auto=format&fit=crop&w=700&q=80",
  machine: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=700&q=80",
  connector: "https://images.unsplash.com/photo-1606813907291-d86efa9b94db?auto=format&fit=crop&w=700&q=80",
  wire: "https://images.unsplash.com/photo-1606813907291-d86efa9b94db?auto=format&fit=crop&w=700&q=80",
  safety: "https://images.unsplash.com/photo-1603398938378-e54eab446dde?auto=format&fit=crop&w=700&q=80",
  accessories: "https://images.unsplash.com/photo-1518779578993-ec3579fee39f?auto=format&fit=crop&w=700&q=80",
};

const iconAliases = {
  battery: "FaBatteryFull",
  inverter: "FaBolt",
  chip: "FaMicrochip",
  pack: "FaCarBattery",
  plug: "FaPlug",
  machine: "FaTools",
  connector: "FaPlug",
  wire: "FaProjectDiagram",
  shield: "FaFireExtinguisher",
  tools: "FaTools",
};

const categoryIdAliases = {
  "epoxy-fiber-sheet": "epoxy-sheet-battery",
  "32140-battery-cell-holder": "cell-holder",
  "32700-nickel-strip": "nickel-strip",
  "32140-nickel-strip": "nickel-strip",
  "18650-nickel-strip": "nickel-strip",
  "metal-battery-box-for-lithium-battery-pack": "battery-metal-box",
  "sb-50-connector": "sb50-connector",
};

export const normalizeCategoryId = (value = "") => {
  const id = String(value).trim().replace(/^jantarides\.ev\.category\./, "");
  return categoryIdAliases[id] || id;
};

export const normalizeCategory = (category) => ({
  ...category,
  id: normalizeCategoryId(category.id),
  count: category.count || category.productCount || 0,
  icon: iconAliases[category.icon] || category.icon || "FaBatteryFull",
  image: category.image || categoryImages[normalizeCategoryId(category.id)] || categoryImages.accessories,
});

export const getCategories = async () => {
  const data = await apiRequest("/categories");
  return (data.categories || []).map(normalizeCategory);
};

export const getCategoryById = async (id) => {
  const categories = await getCategories();
  return categories.find((category) => category.id === id);
};
